export default "__VITE_ASSET__45c2e85f__"